import React from 'react';
import { Col } from 'antd';

import { FontSize, FontWeight } from '@common/tokens';

export const Column = ({
  label,
  children,
  divider,
  xs,
  md,
  lg,
  className = '',
}: React.PropsWithChildren<{
  label: string | React.ReactNode;
  divider?: boolean;
  xs?: number;
  md?: number;
  lg?: number;
  className?: string;
}>) => {
  const dividerClassname = divider
    ? 'template-details-col divider'
    : 'template-details-col';

  return (
    <React.Fragment>
      <Col
        xs={xs}
        md={md}
        lg={lg}
        className={`${className} ${dividerClassname}`}
      >
        {React.isValidElement(label) ? (
          label
        ) : (
          <span className="column-label">{label}</span>
        )}
        {children}
      </Col>
      <style jsx>{`
        .column-label {
          display: block;
          font-size: ${FontSize.xs};
          font-weight: ${FontWeight.light};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
      <style jsx>{`
        :global(.template-details-col) {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
    </React.Fragment>
  );
};
